module.exports = __webpack_public_path__ + "img/ww_example_favicon.43bddba4.png";